export { default as theme } from 'prism-themes/themes/prism-a11y-dark.css';
